import { LockingSystemComponentsByUuid } from "@secureo/common/typings/LockingSystem"

export const getLockingSystemMsrpPricePortions = (
	componentsByUuid: LockingSystemComponentsByUuid,
	quantity: number,
) => {
	const { singleNetMsrpPriceCents, singleGrossMsrpPriceCents } = Object.values(
		componentsByUuid,
	).reduce(
		(lockingSystemMsrpPricePortions, component) => {
			const singleNetMsrpPriceCents =
				lockingSystemMsrpPricePortions.singleNetMsrpPriceCents +
				component.totalNetMsrpPriceCents
			const singleGrossMsrpPriceCents =
				lockingSystemMsrpPricePortions.singleGrossMsrpPriceCents +
				component.totalGrossMsrpPriceCents

			return {
				singleNetMsrpPriceCents,
				singleGrossMsrpPriceCents,
			}
		},
		{
			singleNetMsrpPriceCents: 0,
			singleGrossMsrpPriceCents: 0,
		},
	)

	const totalNetMsrpPriceCents = singleNetMsrpPriceCents * quantity
	const totalGrossMsrpPriceCents = singleGrossMsrpPriceCents * quantity

	return {
		singleNetMsrpPriceCents,
		singleGrossMsrpPriceCents,
		totalNetMsrpPriceCents,
		totalGrossMsrpPriceCents,
	}
}

const getLockingSystemPricePortions = (
	componentsByUuid: LockingSystemComponentsByUuid,
	quantity: number,
) => {
	const { singleNetPriceCents, singleGrossPriceCents } = Object.values(componentsByUuid).reduce(
		(lockingSystemPricePortions, component) => {
			const singleNetPriceCents =
				lockingSystemPricePortions.singleNetPriceCents + component.totalNetPriceCents
			const singleGrossPriceCents =
				lockingSystemPricePortions.singleGrossPriceCents + component.totalGrossPriceCents

			return {
				singleNetPriceCents,
				singleGrossPriceCents,
			}
		},
		{
			singleNetPriceCents: 0,
			singleGrossPriceCents: 0,
		},
	)

	const totalNetPriceCents = singleNetPriceCents * quantity
	const totalGrossPriceCents = singleGrossPriceCents * quantity

	return {
		singleNetPriceCents,
		singleGrossPriceCents,
		totalNetPriceCents,
		totalGrossPriceCents,
	}
}

export default getLockingSystemPricePortions
